import { InjectionToken } from '@angular/core';
import { AnalyticsClient } from './analyticsClient.interface';

export const ANALYTICS_CLIENTS = new InjectionToken<AnalyticsClient>('ANALYTICS_CLIENTS');
